import React, { ReactElement } from 'react';
import styles from './ClassificationTopConcernsByAreaHOC.module.scss';

export const ClassificationTopConcernsByAreaHeader = (): ReactElement => (
  <div className={styles.headerTitle}>Top concerns by area</div>
);
